import { Component } from '@angular/core';

@Component({
    selector: 'app-pinned-group-skeleton',
    standalone: false,
    templateUrl: './pinned-group-skeleton.component.html',
    styleUrl: './pinned-group-skeleton.component.scss',
})
export class PinnedGroupSkeletonComponent {}
